import { gql } from '@apollo/client'

const BASE_CHAPTER_NOTE_FIELDS = gql`
  fragment BaseChapterNoteFields on ChapterNotesType {
    id
    title
    link
    order
    membershipLevel
    createdAt
    updatedAt
  }
`

export const GET_ALL_CHAPTER_NOTES = gql`
  ${BASE_CHAPTER_NOTE_FIELDS}
  query findAllChapterNotes($params: ChapterNotesQueryInput = {}) {
    findAllChapterNotes(query: $params) {
      count
      items {
        ...BaseChapterNoteFields
      }
    }
  }
`

export const GET_ONE_CHAPTER_NOTE = gql`
  ${BASE_CHAPTER_NOTE_FIELDS}
  query findOneChapterNote($params: String!) {
    findOneChapterNotes(id: $params) {
      ...BaseChapterNoteFields
    }
  }
`

export const CREATE_CHAPTER_NOTE = gql`
  mutation createChapterNote($params: CreateChapterNotesInput!) {
    createChapterNotes(createChapterNotesInput: $params) {
      id
    }
  }
`

export const UPDATE_CHAPTER_NOTE = gql`
  mutation updateChapterNote($params: UpdateChapterNotesInput!) {
    updateChapterNotes(updateChapterNotesInputFieldName: $params) {
      id
    }
  }
`

export const REMOVE_CHAPTER_NOTE = gql`
  mutation removeChapterNote($id: String!) {
    removeChapterNotes(id: $id) {
      affected
    }
  }
`

export const BULK_UPDATE_CHAPTER_NOTES = gql`
  mutation bulkUpdateChapterNotes($params: [BulkUpdateChapterNotesInput!]!) {
    bulkUpdateChapterNotes(bulkUpdateChapterNotesInput: $params) {
      id
    }
  }
`
